const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const getLocalUsers = () => {
  try {
    const users = localStorage.getItem('registeredUsers');
    return users ? JSON.parse(users) : [];
  } catch {
    return [];
  }
};

const saveLocalUser = (user) => {
  try {
    const users = getLocalUsers();
    if (!users.some(u => u.email === user.email)) {
      users.push(user);
      localStorage.setItem('registeredUsers', JSON.stringify(users));
    }
  } catch (error) {
    console.error('Error saving local user:', error);
  }
};

export const loginUser = async (email, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}/users`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    
    const serverUsers = await response.json();
    let user = Array.isArray(serverUsers) 
      ? serverUsers.find(u => u.email === email && u.password === password)
      : null;
    
    if (!user) {
      const localUsers = getLocalUsers();
      user = localUsers.find(u => u.email === email && u.password === password);
    }
    
    if (!user) {
      throw new Error('Invalid email or password');
    }

    if (user.isActive === false) {
      throw new Error('Account is blocked. Please contact support.');
    }

    localStorage.setItem('currentUser', JSON.stringify(user));
    localStorage.setItem('isLoggedIn', 'true');
    
    return user;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const registerUser = async (userData) => {
  try {
    if (!userData.name?.trim() || !userData.email?.trim() || !userData.password) {
      throw new Error('All fields are required');
    }

    const checkResponse = await fetch(`${API_BASE_URL}/users`);
    if (!checkResponse.ok) throw new Error(`HTTP ${checkResponse.status}`);
    
    const serverUsers = await checkResponse.json();
    const existingServerUser = Array.isArray(serverUsers) 
      ? serverUsers.find(u => u.email === userData.email.trim())
      : null;
    
    if (existingServerUser) {
      throw new Error('Email already registered');
    }

    const localUsers = getLocalUsers();
    const existingLocalUser = localUsers.find(u => u.email === userData.email.trim());
    if (existingLocalUser) {
      throw new Error('Email already registered');
    }

    const newUser = {
      id: Date.now(),
      name: userData.name.trim(),
      email: userData.email.trim().toLowerCase(),
      password: userData.password,
      role: 'user',
      isActive: true,
      createdAt: new Date().toISOString()
    };

    saveLocalUser(newUser);
    
    localStorage.setItem('currentUser', JSON.stringify(newUser));
    localStorage.setItem('isLoggedIn', 'true');
    
    console.log('Mock: User registered locally', newUser);
    
    return { success: true, user: newUser };
  } catch (error) {
    console.error('Registration error:', error);
    return { 
      success: false, 
      message: error.message || 'Registration failed. Please try again.' 
    };
  }
};

export const logoutUser = () => {
  localStorage.removeItem('currentUser');
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('cart');
  localStorage.removeItem('wishlist');
};

export const getCurrentUser = () => {
  try {
    const userStr = localStorage.getItem('currentUser');
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};

export const isAuthenticated = () => {
  return localStorage.getItem('isLoggedIn') === 'true';
};